import { render, staticRenderFns } from "./LinkUser.vue?vue&type=template&id=c694822e&scoped=true"
import script from "./LinkUser.vue?vue&type=script&lang=js"
export * from "./LinkUser.vue?vue&type=script&lang=js"
import style0 from "./LinkUser.vue?vue&type=style&index=0&id=c694822e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c694822e",
  null
  
)

export default component.exports